import { useEffect, useState } from "react";
import { SortedResultsList, useQuestionizerStore } from "../types/state.ts";

export function FoerderungenByGewerkElement(props: {label: string,  zuschuesse: SortedResultsList, darlehen: SortedResultsList,  zuschuesse_length: number, darlehen_length: number, selected_count:number}){
  const setDarlehenList = useQuestionizerStore(
    (state) => state.setDarlehenList
  );
  const setZuschuesseList = useQuestionizerStore(
    (state) => state.setZuschuesseList
  );
  const setActiveListLabel = useQuestionizerStore(
    (state) => state.setActiveListLabel
  );
  const setActiveListType = useQuestionizerStore(
    (state) => state.setActiveListType
  );
  
  const [open, setOpen] = useState<boolean>(false);

  const open_darlehen = ()=>{
            setActiveListLabel(props.label);
            setActiveListType("darlehen");
            setZuschuesseList(props.zuschuesse);
            setDarlehenList(props.darlehen);
          };
  const open_zuschuesse = ()=>{
            setActiveListLabel(props.label + " ("+(props.zuschuesse_length+props.darlehen_length)+")");
            setActiveListType("zuschuss");
            setZuschuesseList(props.zuschuesse);
            setDarlehenList(props.darlehen);
          };
  return <div className="flex flex-col" style={{backgroundColor: "var(--neutral-light)"}} 
    tabIndex={0}
    onKeyUp={(event)=>{
      if ((event.code != " ")  && (event.code != "Enter")) { return } 
      setOpen(!open);
    }}
    onClick={()=>{
      setOpen(!open);
    }}>
    <div className="p-4"><b>{props.label} ({props.zuschuesse_length + props.darlehen_length})</b> {props.selected_count ? "( " + props.selected_count + " gemerkt)" : ""}</div>
    <div className="flex flex-row overflow-hidden transition-all" inert={!open} style={{maxHeight: open ? "10rem" : 0, opacity: open ? 1 : 0}}>
      <div className="p-4 flex flex-col w-full">
       {props.zuschuesse_length > 0 && <div className="flex flex-row" 
        tabIndex={0}
        onKeyUp={(event)=>{
          if ((event.code != " ")  && (event.code != "Enter")) { return } 
            open_zuschuesse();
        }}
        onClick={()=>{
            open_zuschuesse();
          }}>
          <span className="text-black">{props.zuschuesse_length} Zuschüsse</span>
          <span className="text-black cursor-pointer underline ml-4">Anzeigen &gt;</span>
        </div>}
        {props.darlehen_length > 0 && <div className="flex flex-row" 
         tabIndex={0}
        onKeyUp={(event)=>{
          if ((event.code != " ")  && (event.code != "Enter")) { return } 
          open_darlehen();
        }}
        onClick={()=>{
            open_darlehen();
          }}>
          <span className="text-black">{props.darlehen_length} Darlehen</span>
          <span className="text-black cursor-pointer underline ml-4">Anzeigen &gt;</span>
        </div>}
      </div>
    </div>
  </div>
}